import styled, { css } from 'styled-components';

const StyledIframe = styled.div`
  position: relative;
  background: transparent;
  overflow: hidden;
  width: 100%;

  ${props =>
    !props.noRatio &&
    css`
      padding-bottom: 56.25%;
      height: 0;
    `}

  iframe {
    outline: none;
    border: none;
    width: 100%;

    ${props =>
      !props.noRatio &&
      css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      `}
  }
`;

export default StyledIframe;
